const lang = {
  title_page: process.env.MIX_APP_NAME,
  title: 'パスワード再設定申込み完了',
  content: 'ご入力いただいたメールアドレスにパスワード<br/>再設定ページのアドレスをお送りしました。',
  button: 'ログイン画面へ',
}

export default lang
